import { IModule } from 'redux-dynamic-modules';
import { eligibilityLookupSlice } from './eligibility-lookup.slice';

export interface EligibilityState {
  eligibility: any;
}

export const getMemberCheckModule = (): IModule<EligibilityState> => ({
  id: eligibilityLookupSlice.name,
  reducerMap: {
    eligibility: eligibilityLookupSlice.reducer,
  },
});
